<template>
  <div class="counter">
    <span class="counter__small">wybrałeś już</span>
    <span class="counter__big">{{votesDone}} z {{votesAll}}</span>
    <span class="counter__small">utworów</span>
    <div class="counter__button-comntainer">
      <SelectButton
        buttonName="głosuj"
        :action="sendVotes"
      />
    </div>
  </div>
</template>

<script>
import SelectButton from '@/ui/SelectButton.vue';

export default {
  name: "vote-counter",
  props: ["votesDone", "votesAll"],
  components: {
    SelectButton
  },
  data() {
    return {
    };
  },
  methods: {
    sendVotes(){
      this.$emit('sendVotes');
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.counter {
  width: 11.875rem;
  height: 11.875rem;
  z-index: 99;
  right: 5%;
  top: 36%;
  background-image: url("~@/assets/voteCounter__background.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #d0d0e0;
  font-family: "Poppins", sans-serif;
  box-sizing: border-box;

  &__small {
    text-transform: uppercase;
    &--two {
      margin-top: 0.3rem;
    }
  }
  &__big {
    font-size: 1.8rem;
    margin-top: 0.8rem;
    margin-bottom: 0.8rem;
  }
  &:after {
    content: "";
    content: "";
    width: 11.375rem;
    height: 12.475rem;
    border: 0.4rem solid #646878;
    position: absolute;
    top: -0.7rem;
    left: 0rem;
    border-radius: 16px;
  }
  &__button-comntainer {
    width: 50%;
    margin-bottom: -1rem;
    z-index: 3;
  }
}
</style>
